import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import rules from '@/utils/rules'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.$rules = rules
new Vue({
  render: (h) => h(App)
}).$mount('#app')
